import { create } from 'zustand';
export const useAsyncRelatedQueriesStore = create((set) => ({
    byEntryId: {},
    clearRelatedQueries: (entryId) => set((state) => {
        const { [entryId]: _, ...byEntryId } = state.byEntryId;
        return { byEntryId };
    }),
    setRelatedQueries: (entryId, payload) => set((state) => ({ byEntryId: { ...state.byEntryId, [entryId]: payload } })),
}));
/**
 * Subscribe to the async related-query results for a single entry, if any have
 * been delivered this session.
 */
export function useAsyncRelatedQueries(entryId) {
    return useAsyncRelatedQueriesStore((state) => (entryId ? state.byEntryId[entryId] : undefined));
}
//# sourceMappingURL=asyncRelatedQueriesStore.js.map